import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE = "https://shophoneynuts.com";

const PAGES = {
  "/": ["HONEY NUTS — Honey with mixed nuts and seeds | Coming soon to Australia",
    "HONEY NUTS is honey with almonds, cashews, walnuts, pistachios, peanuts, sunflower kernels and sesame seeds in a 750 g jar. Join the launch list to hear when it's available in Australia."],
  "/shop": ["HONEY NUTS 750 g jar — Honey with mixed nuts and seeds",
    "60% honey and 40% nuts and seeds in a 750 g hexagonal glass jar. Ingredients, allergens and delivery details. Not yet available — join the launch list."],
  "/about": ["About HONEY NUTS",
    "The story behind HONEY NUTS: honey with mixed nuts and seeds for yoghurt, porridge or toast."],
  "/faq": ["FAQ — HONEY NUTS",
    "Answers about the HONEY NUTS 750 g jar, allergens, delivery and when you can buy it."],
  "/contact": ["Contact HONEY NUTS",
    "Questions about HONEY NUTS or an order? Send us a message and we'll reply by email."],
};

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) { el?.remove(); return; }
  if (!el) { el = document.createElement("link"); el.rel = "canonical"; document.head.appendChild(el); }
  el.href = href;
};

export const useJsonLd = (id, data) => {
  useEffect(() => {
    if (!data) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `ld-${id}`;
    el.text = JSON.stringify(data);
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, [id, data]);
};

// Public pages listed in PAGES are indexable; every other route (accounts, checkout, admin, drafts, 404) is noindex.
export const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGES[pathname];
    document.title = page ? page[0] : "HONEY NUTS";
    setMeta("name", "description", page ? page[1] : PAGES["/"][1]);
    setMeta("name", "robots", page ? "index, follow" : "noindex, nofollow");
    setCanonical(page ? `${SITE}${pathname === "/" ? "/" : pathname}` : null);
    setMeta("property", "og:title", document.title);
    setMeta("property", "og:description", page ? page[1] : PAGES["/"][1]);
    setMeta("property", "og:url", page ? `${SITE}${pathname}` : SITE + "/");
  }, [pathname]);
  return null;
};
